let sessionStorageAvailable = null;

function checkAvailability() {
  if (sessionStorageAvailable !== null) {
    return sessionStorageAvailable;
  }
  try {
    const key = '__session_test__';
    sessionStorage.setItem(key, '1');
    sessionStorage.removeItem(key);
    sessionStorageAvailable = true;
  } catch (e) {
    sessionStorageAvailable = false;
  }
  return sessionStorageAvailable;
}

const storeSession = {
  isAvailable: function() {
    return checkAvailability();
  },

  get: function(key, defaultValue) {
    if (!checkAvailability()) {
      return defaultValue;
    }
    let val = sessionStorage.getItem(key);
    return val !== null ? val : defaultValue;
  },

  set: function(key, value) {
    if (!checkAvailability()) {
      return;
    }
    sessionStorage.setItem(key, value);
  },

  clear: function(key) {
    if (!checkAvailability()) {
      return;
    }
    sessionStorage.removeItem(key);
  },

  getRtcInitReloadCount: function(lessonId) {
    return parseInt(this.get(`mystage_rtcInitReload_${lessonId}`, 0), 10);
  },

  setRtcInitReloadCount: function(lessonId, count) {
    this.set(`mystage_rtcInitReload_${lessonId}`, count);
  },

  clearRtcInitReloadCount: function(lessonId) {
    this.clear(`mystage_rtcInitReload_${lessonId}`);
  }
};

export { storeSession };
